import { DevsiteCookies } from 'shared/models/cookies';
import { getCookie } from '../DevsiteCookies';
import { HeaderKeys, HttpClientResponse, QueryParameters, RequestHeaders } from './Definitions';
import { RegionalSubdomainExecutor } from './RegionalSubdomainExecutor';

// uses cookies on the devsite domain for authentication
export default class StudioBuilderRequestExecutor<T extends string> extends RegionalSubdomainExecutor<T> {
  protected execute(
    url: string,
    params: Partial<RequestInit>,
    headers?: RequestHeaders,
    queryParams?: QueryParameters
  ): Promise<HttpClientResponse> {
    return super.execute(
      url,
      params,
      this.getHeaders(headers),
      queryParams,
      { credentials: 'include' } // include this so that devsite cookies are sent to studiobuilder
    );
  }

  // Add X-XSRF-TOKEN header, based off the XSRF-TOKEN cookie, for csrf security for builder server.
  // These identifiers are unique to Spring sessions & web security and is currently specific to AB/OB only.
  getHeaders(headers?: RequestHeaders): RequestHeaders {
    const combinedHeaders = { [HeaderKeys.ORG_ID]: getCookie(DevsiteCookies.WCP_ORG_UUID), ...headers };
    const xsrfToken = getCookie(DevsiteCookies.FB_XSRF_TOKEN);
    if (xsrfToken) {
      combinedHeaders['X-XSRF-TOKEN'] = xsrfToken;
    }
    return combinedHeaders;
  }
}
